module.exports = __webpack_public_path__ + "img/2.6_About-Us_Key-Partner_15_UTS.409a328107102bb14e357184b2bed062.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2.6_About-Us_Key-Partner_15_UTS.png
// module id = 777
// module chunks = 0